var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import { getDialogBodySx, getDialogDismissButtonSx, getDialogSx, getDialogTitleSx, getDialogTitleTextSx, } from '@revdotcom/vaporwave-sx';
import { forwardCommonProps } from '../../Helpers/CommonProps';
import SvgClose from '../Internal/Icons/SvgClose';
export var DialogContent = function (_a) {
    var _b;
    var title = _a.title, children = _a.children, onAnimationEnd = _a.onAnimationEnd, dialogRef = _a.dialogRef, _c = _a.isStatic, isStatic = _c === void 0 ? false : _c, overlayProps = _a.overlayProps, dialogProps = _a.dialogProps, titleProps = _a.titleProps, _d = _a.overflowY, overflowY = _d === void 0 ? 'auto' : _d, rest = __rest(_a, ["title", "children", "onAnimationEnd", "dialogRef", "isStatic", "overlayProps", "dialogProps", "titleProps", "overflowY"]);
    return (_jsxs("div", __assign({ "data-ismodal": true, onAnimationEnd: onAnimationEnd, ref: dialogRef }, overlayProps, dialogProps, forwardCommonProps(rest), { sx: getDialogSx(rest.isOpen, isStatic, rest.width != undefined), children: [_jsxs("div", __assign({}, titleProps, { sx: getDialogTitleSx(), children: [_jsx("span", { sx: getDialogTitleTextSx(), children: title }), rest.onClose && (_jsx("button", { onClick: rest.onClose, sx: getDialogDismissButtonSx(), children: _jsx(SvgClose, {}) }))] })), _jsx("div", { sx: getDialogBodySx(overflowY, (_b = rest.height) === null || _b === void 0 ? void 0 : _b.toString()), children: children })] })));
};
